import REDUX_OPTION from '../../../../redux/constants/option'
import { getPathReduxUtil } from '../../../../redux/utils/get-path'
import getPathFromDomainPathReduxUtil from '../../../../redux/utils/get-path-from-domain-path'
import { isDownloadedReduxUtil } from '../../../../redux/utils/is-downloaded'
import isNewReduxUtil from '../../../../redux/utils/is-new'
import { WORKOUT_CLASS_NAME } from '../../..'
import WORKOUTS_ACTION from '../../constants/action'
import WORKOUTS_DOMAIN from '../../constants/domain'
import WORKOUTS_ENDPOINT from '../../constants/endpoint'
import getByIdWorkoutSelector from '../../selectors/get-by-id'
import { logUtil } from 'packages/src'
import { loadInstanceReduxAction } from '../../../../redux/actions/load-instance'

function loadByIdWorkoutAction (id, options = {}) {
  return async (dispatch, getState) => {
    if (!id) {
      return
    }

    const workout = getByIdWorkoutSelector(id)(getState())
    if (workout && isNewReduxUtil(workout)) {
      logUtil('loadByIdWorkoutAction')
        .debug('[noop] new workout')
      return
    }

    if (workout && isDownloadedReduxUtil(workout)) {
      logUtil('loadByIdWorkoutAction')
        .debug('[noop] downloaded')
      return
    }

    options[REDUX_OPTION.IS_FORCED] = true
    options[REDUX_OPTION.IGNORE_UPDATED_AT] = true
    try {
      await dispatch(loadInstanceReduxAction({
        type: WORKOUTS_ACTION.LOAD_BY_ID,
        payload: {
          endpoint: `${WORKOUTS_ENDPOINT.WORKOUTS}/${id}`,
          path: workout
            ? getPathReduxUtil(workout)
            : getPathFromDomainPathReduxUtil(WORKOUTS_DOMAIN, id),
          data: workout
            ? null
            : {
                id,
                className: WORKOUT_CLASS_NAME
              },
          options
          // query
        }
      }))

      // if (workout) {
      // return dispatch(loadExercisesWorkoutAction(id))
      // }
    } catch (error) {
      logUtil('').error(`loading workouts with id ${id} failed `, error)
    }
  }
}

export default loadByIdWorkoutAction
